import { supabase } from '../lib/supabase';

export const blogService = {
  async getPublishedPosts(filters = {}) {
    let query = supabase
      .from('blog_posts')
      .select(`
        *,
        blog_categories(id, name, slug)
      `)
      .eq('status', 'published')
      .order('published_at', { ascending: false });

    if (filters.targetPage) {
      query = query.eq('target_page', filters.targetPage);
    }

    if (filters.limit) {
      query = query.limit(filters.limit);
    }

    const { data, error } = await query;
    if (error) throw error;
    
    return data?.map(post => ({
      ...post,
      category: post.blog_categories,
      targetPage: post.target_page
    })) || [];
  },

  async searchPosts(searchTerm) {
    if (!searchTerm) return [];
    
    const { data, error } = await supabase
      .from('blog_posts')
      .select(`
        *,
        blog_categories(id, name, slug)
      `)
      .eq('status', 'published')
      .or(`title.ilike.%${searchTerm}%,content.ilike.%${searchTerm}%,excerpt.ilike.%${searchTerm}%`)
      .order('published_at', { ascending: false });

    if (error) throw error;
    
    return data?.map(post => ({
      ...post,
      category: post.blog_categories,
      targetPage: post.target_page
    })) || [];
  },

  async incrementPostSentiment(postId, isHelpful) {
    const { error } = await supabase.rpc('increment_post_sentiment', {
      post_id: postId,
      is_helpful: isHelpful
    });
    if (error) throw error;
    return true;
  },

  async incrementPostViews(postId) {
    const { error } = await supabase.rpc('increment_blog_post_views', {
      post_id: postId
    });
    if (error) throw error;
    return true;
  },

  async getPostBySlug(slug) {
    const { data, error } = await supabase
      .from('blog_posts')
      .select(`
        *,
        blog_categories(id, name, slug)
      `)
      .eq('slug', slug)
      .eq('status', 'published')
      .single();

    if (error) throw error;
    
    return {
      ...data,
      category: data.blog_categories
    };
  },

  async getCategories() {
    const { data, error } = await supabase
      .from('blog_categories')
      .select('*')
      .order('name');

    if (error) throw error;
    return data;
  },

  async getPageSettings(pageId) {
    const { data, error } = await supabase
      .from('resource_page_settings')
      .select('*')
      .eq('page_id', pageId)
      .maybeSingle();

    if (error) throw error;
    return data;
  },

  async getPlatformSettings(key) {
    const { data, error } = await supabase
      .from('platform_settings')
      .select('value')
      .eq('key', key)
      .maybeSingle();

    if (error) throw error;
    return data?.value;
  },

  async getAllPageSettings() {
    const { data, error } = await supabase
      .from('resource_page_settings')
      .select('*');
    if (error) throw error;
    return data;
  },

  async updatePageSettings(pageId, settings) {
    const { data, error } = await supabase
      .from('resource_page_settings')
      .update(settings)
      .eq('page_id', pageId)
      .select()
      .single();

    if (error) throw error;
    return data;
  }
};
